import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight, Sparkles } from 'lucide-react';
export function HeroSection() {
  const handleCheckout = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden bg-holistic-cream" data-id="element-68">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-69">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-holistic-sand rounded-full blur-3xl opacity-50" data-id="element-70"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-holistic-sage-light rounded-full blur-3xl opacity-20" data-id="element-71"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-72">
        <div className="order-2 md:order-1" data-id="element-73">
          <FadeIn data-id="element-74">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-holistic-sand text-holistic-earth-light text-sm font-medium mb-6" data-id="element-75">
              <Sparkles size={16} className="text-holistic-gold" data-id="element-76" />
              <span data-id="element-77">Método de Bio-Reprogramación</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-holistic-earth leading-tight mb-6" data-id="element-78">
              Cómo Sanar tus Síntomas Físicos desde la Raíz.
            </h1>
            <p className="text-lg md:text-xl text-holistic-earth-light mb-8 leading-relaxed" data-id="element-79">
              Sin depender de fármacos ni tratamientos costosos. Descubre el{' '}
              <strong className="text-holistic-earth font-semibold" data-id="element-80">
                Código de Autocuración
              </strong>
              : El método que está ayudando a miles de personas a descodificar
              el origen emocional de sus dolores y recuperar la salud de forma
              natural.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-81">
              <Button size="lg" onClick={handleCheckout} className="w-full sm:w-auto group" data-id="element-82">
                ¡SÍ! QUIERO MI CÓDIGO DE AUTOCURACIÓN
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} data-id="element-83" />
              </Button>
              <span className="text-holistic-earth-light font-medium" data-id="element-84">
                Solo $16.999 ARS
              </span>
            </div>
          </FadeIn>
        </div>

        <div className="order-1 md:order-2 relative" data-id="element-85">
          <FadeIn direction="left" delay={0.2} data-id="element-86">
            <p className="md:text-lg font-serif font-semibold text-holistic-wine text-center mb-4 max-w-md mx-auto text-[28px]" data-id="element-87">
              Eliminá distintos tipos de dolor y enfermedades psicosomáticas en
              minutos.
            </p>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] max-w-md mx-auto" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/oCxU4AUyZpxurHE27VVz5s/ChatGPT_Image_8_jun_2026,_11_23_53.png" alt="Mujer en paz con energía sanadora en el pecho" className="w-full h-full object-cover" data-id="element-89" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 md:-left-12 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 max-w-xs" data-id="element-90">
              <div className="bg-holistic-sage/10 p-3 rounded-full" data-id="element-91">
                <Sparkles className="text-holistic-sage" size={24} data-id="element-92" />
              </div>
              <div data-id="element-93">
                <p className="text-sm font-bold text-holistic-earth" data-id="element-94">
                  100% Natural
                </p>
                <p className="text-xs text-holistic-earth-light" data-id="element-95">
                  Resultados comprobados
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}